import { STATS_FONT_MAX, STATS_FONT_MIN } from '@/utils/statsFont';

const btn = (disabled: boolean) => ({
  padding: '3px 8px', fontSize: 11, fontWeight: 700, borderRadius: 6, border: '1px solid #e2e8f0',
  background: 'white', color: disabled ? '#cbd5e1' : '#475569', cursor: disabled ? 'default' : 'pointer', lineHeight: 1.2,
}) as const;

/** A− / A+ for the Ctr Stats text only (independent of page zoom). */
export function StatsFontControls({ size, onChange }: { size: number; onChange: (px: number) => void }) {
  return (
    <span style={{ display: 'inline-flex', gap: 3, flexShrink: 0 }}>
      <button
        type="button" aria-label="Decrease stats font size" title={`Smaller stats text (${size}px)`}
        disabled={size <= STATS_FONT_MIN} onClick={() => onChange(size - 1)} style={btn(size <= STATS_FONT_MIN)}
      >A−</button>
      <button
        type="button" aria-label="Increase stats font size" title={`Larger stats text (${size}px)`}
        disabled={size >= STATS_FONT_MAX} onClick={() => onChange(size + 1)} style={btn(size >= STATS_FONT_MAX)}
      >A+</button>
    </span>
  );
}
